import { t } from '@framework/i18n';
import { yup } from '@framework/validation';

export const CreateCommunicationRequestSchema = yup.object({
  idTipoComunicazione: yup
    .string()
    .label(
      t(
        'communication-request-schema.communication-type',
        'Tipo Comunicazione',
      ),
    )
    .required()
    .when(['$isEdit'], ([isEdit], schema) => {
      return !isEdit ? schema.required() : schema.notRequired().strip();
    }),
  idIstanzaProcedimento: yup.string().notRequired(),
  idProcedimentoMittente: yup
    .string()
    .notRequired()
    .label(
      t(
        'communication-request-schema.sender-office',
        'Ufficio Mittente',
      ),
    ),
  idDestinatarioEndoprocedimentoPrimoLivello: yup
    .string()
    .notRequired()
    .label(
      t(
        'communication-request-schema.receiver-office',
        'Ufficio Destinatario',
      ),
    ),
  flCaricataManualmente: yup
    .boolean()
    .notRequired()
    .label(
      t(
        'communication-request-schema.manually-loaded',
        'Caricata Manualmente',
      ),
    ),
  noteAddizionali: yup
    .string()
    .notRequired()
    .label(
      t(
        'communication-request-schema.addictional-notes',
        'Note Addizionali',
      ),
    )
    .when(['flCaricataManualmente'], ([flCaricataManualmente], schema) => {
      return flCaricataManualmente
        ? schema.notRequired().strip()
        : schema.notRequired();
    }),
  // Manuali
  dataProtocollo: yup
    .string()
    .stringDate('YYYY-MM-DD[T]HH:mm:ss')
    .required()
    .label(
      t(
        'communication-request-schema.protocol-date',
        'Data Protocollo',
      ),
    )
    .when(['flCaricataManualmente'], ([flCaricataManualmente], schema) =>
      flCaricataManualmente ? schema.required() : schema.notRequired().strip(),
    ),
  numeroProtocollo: yup
    .string()
    .required()
    .label(
      t(
        'communication-request-schema.protocol-number',
        'Numero Protocollo',
      ),
    )
    .when(['flCaricataManualmente'], ([flCaricataManualmente], schema) =>
      flCaricataManualmente ? schema.required() : schema.notRequired().strip(),
    ),
  oggetto: yup
    .string()
    .notRequired()
    .label(t('communication-request-schema.subject', 'Oggetto'))
    .when(['flCaricataManualmente'], ([flCaricataManualmente], schema) =>
      flCaricataManualmente ? schema.required() : schema.notRequired().strip(),
    ),
  messaggio: yup
    .string()
    .notRequired()
    .label(t('communication-request-schema.message', 'Messaggio'))
    .when(['flCaricataManualmente'], ([flCaricataManualmente], schema) =>
      flCaricataManualmente ? schema.required() : schema.notRequired().strip(),
    ),
});

export type CreateCommunicationRequest = yup.InferType<
  typeof CreateCommunicationRequestSchema
>;
